import { Input } from '@builder.io/sdk';

import buttonStyling from '../parts/buttonStyling';

export const link = [
  { name: 'text', type: 'text', defaultValue: 'Shop Now' },
  { name: 'link', type: 'text', defaultValue: '/' },
  {
    name: 'newTab',
    friendlyName: 'Open in new tab',
    type: 'boolean',
    defaultValue: false
  },
  {
    name: 'fullWidth',
    friendlyName: 'Full Width',
    type: 'boolean',
    defaultValue: false
  },
  { name: 'title', friendlyName: 'Title', type: 'string', defaultValue: '' },
  {
    name: 'ariaLabel',
    friendlyName: 'Aria Label',
    type: 'string',
    defaultValue: ''
  },
  buttonStyling
] satisfies Array<Input>;
